import PlayerSearch from '@/components/PlayersSearch/PlayersSearch.example';

export default PlayerSearch;
